<section class="h-full flex flex-col gap-2 z-0 relative overflow-y-auto  p-2 lg:pl-0">
<div class="max-w-6xl p-4 rounded-lg bg-white dark:bg-zinc-950 border" [ngClass]="{
            'shadow-lg border border-zinc-950/10 dark:border-white/10': source !== 'modal'
          }">
        <form [formGroup]="companyForm" (keydown.enter)="$event.preventDefault()">
            <h1 *ngIf="source !== 'modal'" class="heading">
                {{companyId ? 'Edit' : 'Add'}}
            </h1>
            <hr *ngIf="source !== 'modal'" class="my-4 mt-4 w-full border-t border-zinc-950/10 dark:border-white/10" />
            <label class="heading">
                <h2>General Information</h2>
            </label>
            <section class="grid gap-4 sm:grid-cols-2">
                <div class="space-y-1">
                    <label class="subheading">
                        Name <span class="text-red-600">*</span>
                    </label>
                    <div>
                        <div>
                            <input formControlName="name" type="text" />
                        </div>
                        <div *ngIf="submitted && form.name.errors">
                            <p *ngIf="form.name.errors.required" class="pt-1 text-red-600 text-xs">
                                Name is required
                            </p>
                        </div>
                    </div>
                </div>
                <div class="space-y-1">
                    <label class="subheading">
                        Email <span class="text-red-600">*</span>
                    </label>
                    <div>
                        <div>
                            <input formControlName="email" type="email" />
                        </div>
                        <div *ngIf="submitted && form.email.errors">
                            <p *ngIf="form.email.errors.required" class="pt-1 text-red-600 text-xs">
                                Email is required
                            </p>
                            <p *ngIf="form.email.errors.email" class="pt-1 text-red-600 text-xs">
                                Valid Email is required
                            </p>
                        </div>

                </div>
            </div>
            <ng-container formGroupName="address">
                <div class="space-y-1">
                    <label class="subheading">
                        Address <span class="text-red-600">*</span>
                    </label>
                    <div>
                        <input googlePlace (onSelect)="onSelectAddress($event)" (input)="onChangeAddress()" formControlName="name" type="text"
                          placeholder="Enter the address" />
                          <div *ngIf="submitted">
                                <div class="error">
                                    <p *ngIf="address.get('name')?.errors?.required" class="mt-2 text-red-600 text-xs">
                                        Address is required
                                    </p>
                                    <p *ngIf="address?.errors?.invalidAddress"
                                        class="mt-2 text-red-600 text-xs">
                                        Invalid address (select from the dropdown)
                                    </p>
                                </div>
                            </div>
                      </div>
                      
                </div>
                <div class="space-y-1">
                    <label class="subheading">
                        City <span class="text-red-600">*</span>
                    </label>
                    <div>
                        <input formControlName="city" type="text" placeholder="" />
                        <div *ngIf="submitted && address.get('city')?.errors">
                            <p *ngIf="address.get('city')?.errors?.required" 
                               class="pt-1 text-red-600 text-xs">
                              City is required
                            </p>
                          </div>
                    </div>
                </div>
                <div class="space-y-1">
                    <label class="subheading">
                        State <span class="text-red-600">*</span>
                    </label>
                    <div>
                        <input formControlName="state" type="text" placeholder="" />
                        <div *ngIf="submitted && address.get('state')?.errors">
                            <p *ngIf="address.get('state')?.errors?.required" 
                               class="pt-1 text-red-600 text-xs">
                               State is required
                            </p>
                          </div>
                    </div>
                </div>
            </ng-container>
            <div class="space-y-1">
                <label class="subheading">
                    Contact Number <span class="text-red-600">*</span>
                </label>
                <div>
                    <input formControlName="phoneNumber" type="text" placeholder=""  />
                    <div *ngIf="submitted && form.phoneNumber.errors">
                        <p *ngIf="form.phoneNumber.errors.required" class="pt-1 text-red-600 text-xs">
                            Contact Number is required
                        </p>
                        <p *ngIf="submitted && form.phoneNumber.errors?.minlength || submitted && form.phoneNumber.errors.maxlength" class="pt-1 text-red-600 text-xs">
                                Minimum 10 digits are required and maximum 13 digits are allowed
                            </p>
                    </div>
                </div>
            </div>
            <div class="space-y-1">
                <label class="subheading">
                    Secondary Contact Number 
                </label>
                <div>
                    <input formControlName="secondaryPhoneNumber" type="text" />
                    <div *ngIf="submitted && form.secondaryPhoneNumber.errors">
                        <p *ngIf="submitted && form.secondaryPhoneNumber.errors?.minlength || submitted && form.secondaryPhoneNumber.errors.maxlength"
                            class="pt-1 text-red-600 text-xs">
                            Minimum 10 digits are required and maximum 13 digits are allowed
                        </p>
                    </div>
                </div>
            </div>
            <div class="space-y-1">
                <label class="subheading">
                    Time Zone <span class="text-red-600">*</span>
                </label>
                <div>
                    <div>
                        <select formControlName="timeZone">
                            <!-- <option value="">
                                Select the Time Zone
                            </option> -->
                            <option *ngFor="let item of allTimezones" value="{{item}}">
                                {{item}}
                            </option>
                        </select>
                        <div *ngIf="submitted && form.timeZone.errors">
                        <p *ngIf="form.timeZone.errors.required" class="pt-1 text-red-600 text-xs">
                          Time Zone is required
                        </p>
                      </div>
                    </div>
                </div>
            </div>
            <div class="space-y-1">
                <label class="subheading">
                    Web URL
                </label>
                <div>
                    <div>
                        <input formControlName="webURL" type="text" />
                    </div>
                </div>
            </div>
             <div class="space-y-1">
                <label class="subheading">Service Area(s)
                    <span class="text-red-600">*</span>
                </label>
                <div>
                    <!-- Using items input with multiple selection -->
                    <ng-select [ngModelOptions]="{standalone: true}" [items]="serviceAreas" bindLabel="title" bindValue="id"
                        [(ngModel)]="selectedServiceArea" [multiple]="true" [clearable]="false" [closeOnSelect]="false"
                        placeholder="Select Service Area(s)" [searchable]="true">
                    </ng-select>
            
                    <!-- Validation Message -->
                    <div *ngIf="submitted && selectedServiceArea?.length === 0">
                        <p *ngIf="form.serviceAreas?.errors?.required" class="pt-1 text-red-600 text-xs">
                            Service Area(s) are required
                        </p>
                    </div>
                </div>
            </div>
            <!-- <div class="space-y-1">
                <label class="subheading">
                    Hours of Operation
                </label>
                <div>
                    <div>
                        <input formControlName="hoursofOperation" type="text" />
                    </div>
                </div>
            </div> -->
            
        </section>
        <div class="mt-4">
              <div class="space-y-2 p-4  rounded-lg bg-white dark:bg-zinc-900 border 
                shadow-lg border-zinc-950/10 dark:border-white/10">

                <div class="flex items-center gap-2 mb-6">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-blue-500" fill="none" viewBox="0 0 24 24"
                        stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                            d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                    <label class="subheading">Hours of Operation</label>
                </div>
                <div>
                    <div>
                        <div class="grid grid-cols-8 gap-2">
                            <div class="col-span-1">
                                <div class="space-y-2">
                                    <div class="flex items-center h-8">
                                        <p class="text-center text-sm font-medium">Days</p>
                                    </div>
                                    <div class="flex items-center h-8">
                                        <p class="text-center text-sm font-medium">Start Time</p>
                                    </div>
                                    <div class="flex items-center h-8">
                                        <p class="text-center text-sm font-medium">End Time</p>
                                    </div>
                                </div>
                            </div>
                            <div class="col-span-7">
                                <div formArrayName="hoursofOperation"  class="grid grid-cols-7 gap-2">
                                    <div *ngFor="let day of operationsArray.controls; let i = index" 
                                        [formGroupName]="i" 
                                        class="space-y-2 p-2"
                                        [ngClass]="{'bg-zinc-950/5 dark:bg-white/5 rounded-md': day.get('enabled')?.value}">
                                        <div class="flex items-center h-8 justify-center">
                                            <p class="text-center text-sm font-medium">
                                                <input formControlName="enabled" type="checkbox" (change)="hoursCheckboxChange(i)" /> {{days[i]}}
                                            </p>
                                        </div>
                                        <div class="flex items-center h-8">
                                            <!-- (afterPickerClosed)="onDateChange(day.get('startTime'))" -->
                                             <!-- (afterPickerClosed)="onTimeChange(day.get('startTime'))" -->
                                            <input type="text" name="start{{i}}" id="start{{i}}" formControlName="startTime" [owlDateTime]="startTime"
                                                [owlDateTimeTrigger]="startTime" />
                                            <owl-date-time [pickerType]="'timer'" #startTime>
                                            </owl-date-time>
                                        </div>
                                        <div *ngIf="submitted && day.get('startTime')?.errors?.required">
                                            <p class="pt-1 text-red-600 text-xs">Start Time is required</p>
                                        </div>
                                        <div class="flex items-center h-8">
                                            <input type="text" name="endTime{{i}}" id="endTime{{i}}" formControlName="endTime" [owlDateTime]="endTime"
                                                [owlDateTimeTrigger]="endTime" />
                                            <owl-date-time [pickerType]="'timer'" #endTime>
                                            </owl-date-time>
                                        </div>
                                        <div *ngIf="submitted && day.get('endTime')?.errors?.required">
                                            <p class="pt-1 text-red-600 text-xs">End Time is required</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            </div>
           
            <div class="space-y-1 mt-4">
                <label class="subheading">
                    Company Logo <span class="text-red-600">*</span>
                </label>
                <div class="flex flex-1 gap-2">
                    <div class="flex-1">
                        <div class="relative overflow-hidden rounded-full inline-flex mt-1">
                           
                            <img  [src]="profileImageURL ? profileImageURL : 'assets/images/company-placeholder.png'"
                                alt="Profile Image" class="relative h-32 w-32 rounded-full border border-main-base" />
                            <label for="Profile"
                                class="absolute inset-0 flex h-full w-full items-center justify-center bg-black bg-opacity-75 text-sm font-medium text-white opacity-0 focus-within:opacity-100 hover:opacity-100">
                                <span>Change</span>
                                <input #logoInput type="file" accept="image/*" style="width: 100%;" 
                                    (change)="processFile(logoInput)" type="file" id="Profile" name="Profile Image"
                                    class="absolute inset-0 h-full w-full cursor-pointer rounded-md border-main-base opacity-0" />
                            </label>
                        </div>
                        <div *ngIf="form.profileImageURL.errors && submitted">
                            <div *ngIf="form.profileImageURL.errors.required" class="error">
                                <p class="mt-2 text-red-600 text-xs">
                                    Company Logo is required
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        <hr class="my-4 w-full border-t border-zinc-950/10 dark:border-white/10" />
        <h2 class="heading">
            Owner Information
        </h2>
        <section class="mt-4 grid gap-4 sm:grid-cols-2">
            <ng-container formGroupName="owner">
                <div class="space-y-1">
                    <label class="subheading">
                        First Name <span class="text-red-600">*</span>
                    </label>
                    <div>
                        <div>
                            <input formControlName="firstName" type="text" />
                        </div>
                    </div>
                    <div *ngIf="submitted && ownerForm.get('firstName')?.errors">
                        <p *ngIf="ownerForm.get('firstName')?.errors?.required" class="pt-1 text-red-600 text-xs">
                            First Name is required
                        </p>
                    </div>
                </div>
                <div class="space-y-1">
                    <label class="subheading">
                        Middle Name
                    </label>
                    <div>
                        <div>
                            <input formControlName="middleName" type="text" />
                        </div>
                    </div>
                </div>
                <div class="space-y-1">
                    <label class="subheading">
                        Last Name <span class="text-red-600">*</span>
                    </label>
                    <div>
                        <div>
                            <input formControlName="lastName" type="text" />
                        </div>
                        <div *ngIf="submitted && ownerForm.get('lastName')?.errors">
                            <p *ngIf="ownerForm.get('lastName')?.errors?.required" class="pt-1 text-red-600 text-xs">
                                Last Name is required
                            </p>
                        </div>
                    </div>
                </div>
                <div class="space-y-1">
                    <label class="subheading">
                        Contact Number
                    </label>
                    <div>
                        <div>
                            <input formControlName="phoneNumber" type="text" />
                        </div>
                         <div *ngIf="submitted && ownerForm.get('phoneNumber')?.errors">
                            <p *ngIf="ownerForm.get('phoneNumber')?.errors?.required" class="pt-1 text-red-600 text-xs">
                                Contact Number is required
                            </p>
                            <p *ngIf="submitted && (ownerForm.get('phoneNumber')?.errors?.minlength || ownerForm.get('phoneNumber')?.errors?.maxlength)"
                                class="pt-1 text-red-600 text-xs">
                                Minimum 10 digits are required and maximum 13 digits are allowed
                            </p>

                        </div>
                    </div>
                </div>
                <div class="space-y-1">
                    <label class="subheading">
                        Email <span class="text-red-600">*</span>
                    </label>
                    <div>
                        <div>
                            <input formControlName="email" type="email" />
                        </div>
                        <div *ngIf="submitted && ownerForm.get('email')?.errors">
                            <p *ngIf="ownerForm.get('email')?.errors?.required" class="pt-1 text-red-600 text-xs">
                                Email is required
                            </p>
                            <p *ngIf="ownerForm.get('email')?.errors?.email" class="pt-1 text-red-600 text-xs">
                              Valid Email is required
                            </p>
                        </div>
                    </div>
                </div>
                <div class="space-y-1">
                    <label class="subheading">
                        Driver's License
                    </label>
                    <div>
                        <div>
                         
                            <input #driverLicenseImageInput type="file" accept="Image/*" 
                                (change)="uploadDocumentImages(driverLicenseImageInput, ownerForm.get('driverLicenseImage'))" />
                        </div>
                        <div class="flex justify-between items-center mt-1">
                            <div class="text-xs text-gray-500">
                                <a *ngIf="ownerForm.get('driverLicenseImage')?.value" target="_blank"
                                    [href]="ownerForm.get('driverLicenseImage')?.value"
                                    class="underline text-blue-600 hover:text-blue-800 visited:text-purple-600">
                                    {{ getFileName(ownerForm.get('driverLicenseImage')?.value) }}
                                </a>
                            </div>
                        </div>
                        <div class="flex justify-end gap-2" *ngIf="ownerForm.get('driverLicenseImage')?.value">
                            <button type="button" [appCopyToClipboard]="ownerForm.get('driverLicenseImage')?.value" copyLabel="document link" copyTooltip="Copy link"
                                class="p-1 border border-zinc-400 dark:border-zinc-600 rounded bg-white dark:bg-zinc-900 text-zinc-900 dark:text-white hover:text-primary hover:border-primary dark:hover:text-primary dark:hover:border-primary flex items-center justify-center outline-none focus:outline-none">
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-4 h-4">
                                    <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 17.25v3.375c0 .621-.504 1.125-1.125 1.125h-9.75a1.125 1.125 0 0 1-1.125-1.125V7.875c0-.621.504-1.125 1.125-1.125H6.75a9.06 9.06 0 0 1 1.5.124m7.5 10.376h3.375c.621 0 1.125-.504 1.125-1.125V11.25c0-4.46-3.243-8.161-7.5-8.876a9.06 9.06 0 0 0-1.5-.124H9.375c-.621 0-1.125.504-1.125 1.125v3.5m7.5 10.375H9.375a1.125 1.125 0 0 1-1.125-1.125v-9.25m12 6.625v-1.875a3.375 3.375 0 0 0-3.375-3.375h-1.5a1.125 1.125 0 0 1-1.125-1.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H9.75" />
                                </svg>
                            </button>
                            <button type="button" (click)="deleteFile(ownerForm.get('driverLicenseImage'), driverLicenseImageInput)"
                                class="p-1 border rounded bg-red-600 flex items-center justify-center outline-none focus:outline-none">
                                <svg class="w-4 h-4 text-white" fill="currentColor" viewBox="0 0 20 20"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path fill-rule="evenodd"
                                        d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z"
                                        clip-rule="evenodd"></path>
                                </svg>
                            </button>
                        </div>
                    </div>
                </div>
                <ng-container formGroupName="address">
                    <div class="space-y-1">
                        <label class="subheading">
                            Address <span class="text-red-600">*</span>
                        </label>
                        <div>
                            <div>
                                <input googlePlace (onSelect)="onSelectOwnerAddress($event)" (input)="onChangeOwnerAddress()" formControlName="name" placeholder="Enter the address"
                                    type="text" />
                            </div>
                            <!-- <div *ngIf="submitted && (ownerForm.get('address.name')?.errors || ownerForm.get('address.coords')?.errors || ownerForm.get('address.coords')?.value?.length === 0)">
                                <p *ngIf="(ownerForm.get('address.name')?.errors?.required || ownerForm.get('address.coords')?.errors?.required || ownerForm.get('address.coords')?.value?.length === 0) " class="pt-1 text-red-600 text-xs">
                                    Address is required
                                </p>
                            </div> -->
                              <div *ngIf="submitted">
                                <div class="error">
                                    <p *ngIf="ownerForm.get('address.name')?.errors?.required" class="mt-2 text-red-600 text-xs">
                                        Address is required
                                    </p>
                                    <p *ngIf="ownerForm.get('address')?.errors?.invalidAddress"
                                        class="mt-2 text-red-600 text-xs">
                                        Invalid address (select from the dropdown)
                                    </p>
                                </div>
                            </div>

                            </div>
                        </div>
                        <div class="space-y-1">
                            <label class="subheading">
                                City <span class="text-red-600">*</span>
                            </label>
                            <div>
                                <div>
                                    <input formControlName="city" type="text" />
                                    <div *ngIf="submitted && (ownerForm.get('address.city')?.errors)">
                                        <p *ngIf="(ownerForm.get('address.city')?.errors?.required)"  class="pt-1 text-red-600 text-xs">
                                        City is required
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="space-y-1">
                            <label class="subheading">
                                State <span class="text-red-600">*</span>
                            </label>
                            <div>
                                <div>
                                    <input formControlName="state" type="text" />
                                     <div *ngIf="submitted && (ownerForm.get('address.state')?.errors)">
                                        <p *ngIf="(ownerForm.get('address.state')?.errors?.required)"  class="pt-1 text-red-600 text-xs">
                                        State is required
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </ng-container>
                </ng-container>
            </section>
            <hr class="my-4 w-full border-t border-zinc-950/10 dark:border-white/10" />
            <h2 class="heading">
                Documents
            </h2>
            <section class="mt-4 grid gap-4 sm:grid-cols-2">
                <ng-container formGroupName="documents">

                    <div class="space-y-1">
                        <label class="subheading">
                            HIPAA Training Certificate
                        </label>
                        <div>
                            <div>
                                <input #hIPAATrainingCertificateImageInput type="file" accept="*"
                                    (change)="uploadDocumentImages(hIPAATrainingCertificateImageInput, document.get('hIPAATrainingCertificateImage'))" />
                            </div>
                            <div class="flex justify-between items-center mt-1">
                                <div class="text-xs text-gray-500">
                                    <a *ngIf="document.get('hIPAATrainingCertificateImage')?.value" target="_blank"
                                        [href]="document.get('hIPAATrainingCertificateImage')?.value"
                                        class="underline text-blue-600 hover:text-blue-800 visited:text-purple-600">
                                        {{ getFileName(document.get('hIPAATrainingCertificateImage')?.value) }}
                                    </a>
                                </div>
                            </div>
                            <div class="flex justify-end gap-2" *ngIf="document.get('hIPAATrainingCertificateImage')?.value">
                                <button type="button" [appCopyToClipboard]="document.get('hIPAATrainingCertificateImage')?.value" copyLabel="document link" copyTooltip="Copy link"
                                    class="p-1 border border-zinc-400 dark:border-zinc-600 rounded bg-white dark:bg-zinc-900 text-zinc-900 dark:text-white hover:text-primary hover:border-primary dark:hover:text-primary dark:hover:border-primary flex items-center justify-center outline-none focus:outline-none">
                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-4 h-4">
                                        <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 17.25v3.375c0 .621-.504 1.125-1.125 1.125h-9.75a1.125 1.125 0 0 1-1.125-1.125V7.875c0-.621.504-1.125 1.125-1.125H6.75a9.06 9.06 0 0 1 1.5.124m7.5 10.376h3.375c.621 0 1.125-.504 1.125-1.125V11.25c0-4.46-3.243-8.161-7.5-8.876a9.06 9.06 0 0 0-1.5-.124H9.375c-.621 0-1.125.504-1.125 1.125v3.5m7.5 10.375H9.375a1.125 1.125 0 0 1-1.125-1.125v-9.25m12 6.625v-1.875a3.375 3.375 0 0 0-3.375-3.375h-1.5a1.125 1.125 0 0 1-1.125-1.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H9.75" />
                                    </svg>
                                </button>
                                <button type="button"
                                    (click)="deleteFile(document.get('hIPAATrainingCertificateImage'), hIPAATrainingCertificateImageInput)"
                                    class="p-1 border rounded bg-red-600 flex items-center justify-center outline-none focus:outline-none">
                                    <svg class="w-4 h-4 text-white" fill="currentColor" viewBox="0 0 20 20"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd"
                                            d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z"
                                            clip-rule="evenodd"></path>
                                    </svg>
                                </button>
                            </div>
                        </div>
                    </div>

                    <div class="space-y-1">
                        <label class="subheading">
                            HIPAA Training Completion Date
                        </label>
                        <div>
                            <div>
                                <input type="text" name="time" id="time" formControlName="hIPAATrainingDate"
                                    [owlDateTime]="dtHIPPATraining" [owlDateTimeTrigger]="dtHIPPATraining" 
                                    [max]="document.get('hIPAATrainingExpireDate')?.value" [readonly]="true" />
                                <owl-date-time [pickerType]="'calendar'"
                                    (afterPickerClosed)="onDateChange(document.get('hIPAATrainingDate'))"
                                    #dtHIPPATraining></owl-date-time>
                            </div>
                        </div>
                    </div>


                    <!-- HIPAA Training Expiration Date -->
                    <div class="space-y-1">
                        <label class="subheading">
                            HIPAA Training Expiration Date
                        </label>
                        <div>
                            <div>
                                <input type="text" name="time" id="time" formControlName="hIPAATrainingExpireDate"
                                    [owlDateTime]="hIPAATrainingExpireDate"
                                    [owlDateTimeTrigger]="hIPAATrainingExpireDate"
                                    [min]="document.get('hIPAATrainingDate')?.value" [readonly]="true" />
                                <owl-date-time [pickerType]="'calendar'"
                                    (afterPickerClosed)="onDateChange(document.get('hIPAATrainingExpireDate'))"
                                    #hIPAATrainingExpireDate></owl-date-time>
                            </div>
                        </div>
                        <div *ngIf="submitted && document.get('hIPAATrainingExpireDate')?.errors">
                            <p *ngIf="document.get('hIPAATrainingExpireDate')?.errors?.dateMismatch" class="pt-1 text-red-600 text-xs">
                                HIPAA Training Expiration Date must be after HIPAA Training Completion Date
                            </p>
                        </div>

                    </div>

                    <div class="space-y-1">
                        <label class="subheading">
                            Fraud, Waste and Abuse Training Certificate
                        </label>
                        <div>
                            <div>
                                <input #fraudWasteAndAbuseCertificateImageInput type="file" accept="Image/*"
                                    (change)="uploadDocumentImages(fraudWasteAndAbuseCertificateImageInput, document.get('fraudWasteAndAbuseCertificateImage'))" />
                            </div>
                            <div class="flex justify-between items-center mt-1">
                                <div class="text-xs text-gray-500">
                                    <a *ngIf="document.get('fraudWasteAndAbuseCertificateImage')?.value" target="_blank"
                                        [href]="document.get('fraudWasteAndAbuseCertificateImage')?.value"
                                        class="underline text-blue-600 hover:text-blue-800 visited:text-purple-600">
                                        {{ getFileName(document.get('fraudWasteAndAbuseCertificateImage')?.value) }}
                                    </a>
                                </div>
                            </div>
                            <div class="flex justify-end gap-2"
                                *ngIf="document.get('fraudWasteAndAbuseCertificateImage')?.value">
                                <button type="button" [appCopyToClipboard]="document.get('fraudWasteAndAbuseCertificateImage')?.value" copyLabel="document link" copyTooltip="Copy link"
                                    class="p-1 border border-zinc-400 dark:border-zinc-600 rounded bg-white dark:bg-zinc-900 text-zinc-900 dark:text-white hover:text-primary hover:border-primary dark:hover:text-primary dark:hover:border-primary flex items-center justify-center outline-none focus:outline-none">
                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-4 h-4">
                                        <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 17.25v3.375c0 .621-.504 1.125-1.125 1.125h-9.75a1.125 1.125 0 0 1-1.125-1.125V7.875c0-.621.504-1.125 1.125-1.125H6.75a9.06 9.06 0 0 1 1.5.124m7.5 10.376h3.375c.621 0 1.125-.504 1.125-1.125V11.25c0-4.46-3.243-8.161-7.5-8.876a9.06 9.06 0 0 0-1.5-.124H9.375c-.621 0-1.125.504-1.125 1.125v3.5m7.5 10.375H9.375a1.125 1.125 0 0 1-1.125-1.125v-9.25m12 6.625v-1.875a3.375 3.375 0 0 0-3.375-3.375h-1.5a1.125 1.125 0 0 1-1.125-1.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H9.75" />
                                    </svg>
                                </button>
                                <button type="button"
                                    (click)="deleteFile(document.get('fraudWasteAndAbuseCertificateImage'), fraudWasteAndAbuseCertificateImageInput)"
                                    class="p-1 border rounded bg-red-600 flex items-center justify-center outline-none focus:outline-none">
                                    <svg class="w-4 h-4 text-white" fill="currentColor" viewBox="0 0 20 20"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd"
                                            d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z"
                                            clip-rule="evenodd"></path>
                                    </svg>
                                </button>
                            </div>
                        </div>
                    </div>

                    <div class="space-y-1">
                        <label class="subheading">
                            Fraud, Waste and Abuse Training Completion Date
                        </label>
                        <div>
                            <div>
                                <input type="text" name="time" id="time"
                                    formControlName="fraudWasteAndAbuseCertificateDate"
                                    [owlDateTime]="dtfraudWasteAndAbuseCertificateDate"
                                    [owlDateTimeTrigger]="dtfraudWasteAndAbuseCertificateDate"
                                    [max]="document.get('fraudWasteAndAbuseCertificateExpireDate')?.value" [readonly]="true" />
                                <owl-date-time [pickerType]="'calendar'"
                                    (afterPickerClosed)="onDateChange(document.get('fraudWasteAndAbuseCertificateDate'))"
                                    #dtfraudWasteAndAbuseCertificateDate></owl-date-time>
                            </div>
                        </div>
                    </div>
                    <!-- Fraud, Waste and Abuse Training Expiration Date -->
                    <div class="space-y-1">
                        <label class="subheading">
                            Fraud, Waste and Abuse Training Expiration Date
                        </label>
                        <div>
                            <div>
                                <input type="text" name="time" id="time"
                                    formControlName="fraudWasteAndAbuseCertificateExpireDate"
                                    [owlDateTime]="fraudWasteAndAbuseCertificateExpireDate"
                                    [owlDateTimeTrigger]="fraudWasteAndAbuseCertificateExpireDate"
                                     [min]="document.get('fraudWasteAndAbuseCertificateDate')?.value" [readonly]="true"  />
                                <owl-date-time [pickerType]="'calendar'"
                                    (afterPickerClosed)="onDateChange(document.get('fraudWasteAndAbuseCertificateExpireDate'))"
                                    #fraudWasteAndAbuseCertificateExpireDate></owl-date-time>
                            </div>
                        </div>
                        <div *ngIf="submitted && document.get('fraudWasteAndAbuseCertificateExpireDate')?.errors">
                            <p *ngIf="document.get('fraudWasteAndAbuseCertificateExpireDate')?.errors?.dateMismatch"
                                class="pt-1 text-red-600 text-xs">
                                Fraud, Waste and Abuse Training Expiration Date must be after Fraud, Waste and Abuse Training Completion Date
                            </p>
                        </div>
                    </div>

                    <div class="space-y-1">
                        <label class="subheading">
                            Signed Non-Disclosure Agreement
                        </label>
                        <div>
                            <div>
                                <input #nonDisclosureAgreementImageInput type="file" accept="Image/*"
                                    (change)="uploadDocumentImages(nonDisclosureAgreementImageInput, document.get('nonDisclosureAgreementImage'))" />
                            </div>
                            <div class="flex justify-between items-center mt-1">
                                <div class="text-xs text-gray-500">
                                    <a *ngIf="document.get('nonDisclosureAgreementImage')?.value" target="_blank"
                                        [href]="document.get('nonDisclosureAgreementImage')?.value"
                                        class="underline text-blue-600 hover:text-blue-800 visited:text-purple-600">
                                        {{ getFileName(document.get('nonDisclosureAgreementImage')?.value) }}
                                    </a>
                                </div>
                            </div>
                            <div class="flex justify-end gap-2" *ngIf="document.get('nonDisclosureAgreementImage')?.value">
                                <button type="button" [appCopyToClipboard]="document.get('nonDisclosureAgreementImage')?.value" copyLabel="document link" copyTooltip="Copy link"
                                    class="p-1 border border-zinc-400 dark:border-zinc-600 rounded bg-white dark:bg-zinc-900 text-zinc-900 dark:text-white hover:text-primary hover:border-primary dark:hover:text-primary dark:hover:border-primary flex items-center justify-center outline-none focus:outline-none">
                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-4 h-4">
                                        <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 17.25v3.375c0 .621-.504 1.125-1.125 1.125h-9.75a1.125 1.125 0 0 1-1.125-1.125V7.875c0-.621.504-1.125 1.125-1.125H6.75a9.06 9.06 0 0 1 1.5.124m7.5 10.376h3.375c.621 0 1.125-.504 1.125-1.125V11.25c0-4.46-3.243-8.161-7.5-8.876a9.06 9.06 0 0 0-1.5-.124H9.375c-.621 0-1.125.504-1.125 1.125v3.5m7.5 10.375H9.375a1.125 1.125 0 0 1-1.125-1.125v-9.25m12 6.625v-1.875a3.375 3.375 0 0 0-3.375-3.375h-1.5a1.125 1.125 0 0 1-1.125-1.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H9.75" />
                                    </svg>
                                </button>
                                <button type="button"
                                    (click)="deleteFile(document.get('nonDisclosureAgreementImage'), nonDisclosureAgreementImageInput)"
                                    class="p-1 border rounded bg-red-600 flex items-center justify-center outline-none focus:outline-none">
                                    <svg class="w-4 h-4 text-white" fill="currentColor" viewBox="0 0 20 20"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd"
                                            d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z"
                                            clip-rule="evenodd"></path>
                                    </svg>
                                </button>
                            </div>
                        </div>
                    </div>

                    <div class="space-y-1">
                        <label class="subheading">
                            Signed Transportation Provider Agreement
                        </label>
                        <div>
                            <div>
                                <input #transportationProviderAgreementImageInput type="file" accept="Image/*"
                                    (change)="uploadDocumentImages(transportationProviderAgreementImageInput, document.get('transportationProviderAgreementImage'))" />
                            </div>
                            <div class="flex justify-between items-center mt-1">
                                <div class="text-xs text-gray-500">
                                    <a *ngIf="document.get('transportationProviderAgreementImage')?.value"
                                        target="_blank"
                                        [href]="document.get('transportationProviderAgreementImage')?.value"
                                        class="underline text-blue-600 hover:text-blue-800 visited:text-purple-600">
                                        {{ getFileName(document.get('transportationProviderAgreementImage')?.value) }}
                                    </a>
                                </div>
                            </div>
                            <div class="flex justify-end gap-2"
                                *ngIf="document.get('transportationProviderAgreementImage')?.value">
                                <button type="button" [appCopyToClipboard]="document.get('transportationProviderAgreementImage')?.value" copyLabel="document link" copyTooltip="Copy link"
                                    class="p-1 border border-zinc-400 dark:border-zinc-600 rounded bg-white dark:bg-zinc-900 text-zinc-900 dark:text-white hover:text-primary hover:border-primary dark:hover:text-primary dark:hover:border-primary flex items-center justify-center outline-none focus:outline-none">
                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-4 h-4">
                                        <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 17.25v3.375c0 .621-.504 1.125-1.125 1.125h-9.75a1.125 1.125 0 0 1-1.125-1.125V7.875c0-.621.504-1.125 1.125-1.125H6.75a9.06 9.06 0 0 1 1.5.124m7.5 10.376h3.375c.621 0 1.125-.504 1.125-1.125V11.25c0-4.46-3.243-8.161-7.5-8.876a9.06 9.06 0 0 0-1.5-.124H9.375c-.621 0-1.125.504-1.125 1.125v3.5m7.5 10.375H9.375a1.125 1.125 0 0 1-1.125-1.125v-9.25m12 6.625v-1.875a3.375 3.375 0 0 0-3.375-3.375h-1.5a1.125 1.125 0 0 1-1.125-1.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H9.75" />
                                    </svg>
                                </button>
                                <button type="button"
                                    (click)="deleteFile(document.get('transportationProviderAgreementImage'), transportationProviderAgreementImageInput)"
                                    class="p-1 border rounded bg-red-600 flex items-center justify-center outline-none focus:outline-none">
                                    <svg class="w-4 h-4 text-white" fill="currentColor" viewBox="0 0 20 20"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd"
                                            d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z"
                                            clip-rule="evenodd"></path>
                                    </svg>
                                </button>
                            </div>
                        </div>
                    </div>

                    <div class="space-y-1">
                        <label class="subheading">
                            W-9 Form
                        </label>
                        <div>
                            <div>
                                <input #w9ImageInput type="file" accept="Image/*"
                                    (change)="uploadDocumentImages(w9ImageInput, document.get('w9Image'))" />
                            </div>
                            <div class="flex justify-between items-center mt-1">
                                <div class="text-xs text-gray-500">
                                    <a *ngIf="document.get('w9Image')?.value" target="_blank"
                                        [href]="document.get('w9Image')?.value"
                                        class="underline text-blue-600 hover:text-blue-800 visited:text-purple-600">
                                        {{ getFileName(document.get('w9Image')?.value) }}
                                    </a>
                                </div>
                            </div>
                            <div class="flex justify-end gap-2" *ngIf="document.get('w9Image')?.value">
                                <button type="button" [appCopyToClipboard]="document.get('w9Image')?.value" copyLabel="document link" copyTooltip="Copy link"
                                    class="p-1 border border-zinc-400 dark:border-zinc-600 rounded bg-white dark:bg-zinc-900 text-zinc-900 dark:text-white hover:text-primary hover:border-primary dark:hover:text-primary dark:hover:border-primary flex items-center justify-center outline-none focus:outline-none">
                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-4 h-4">
                                        <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 17.25v3.375c0 .621-.504 1.125-1.125 1.125h-9.75a1.125 1.125 0 0 1-1.125-1.125V7.875c0-.621.504-1.125 1.125-1.125H6.75a9.06 9.06 0 0 1 1.5.124m7.5 10.376h3.375c.621 0 1.125-.504 1.125-1.125V11.25c0-4.46-3.243-8.161-7.5-8.876a9.06 9.06 0 0 0-1.5-.124H9.375c-.621 0-1.125.504-1.125 1.125v3.5m7.5 10.375H9.375a1.125 1.125 0 0 1-1.125-1.125v-9.25m12 6.625v-1.875a3.375 3.375 0 0 0-3.375-3.375h-1.5a1.125 1.125 0 0 1-1.125-1.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H9.75" />
                                    </svg>
                                </button>
                                <button type="button" (click)="deleteFile(document.get('w9Image'), w9ImageInput)"
                                    class="p-1 border rounded bg-red-600 flex items-center justify-center outline-none focus:outline-none">
                                    <svg class="w-4 h-4 text-white" fill="currentColor" viewBox="0 0 20 20"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd"
                                            d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z"
                                            clip-rule="evenodd"></path>
                                    </svg>
                                </button>
                            </div>
                        </div>
                    </div>

                    <div class="space-y-1">
                        <label class="subheading">
                            Disclosure of Ownership
                        </label>
                        <div>
                            <div>
                                <input #disclosureofOwnershipImageInput type="file" accept="Image/*"
                                    (change)="uploadDocumentImages(disclosureofOwnershipImageInput, document.get('disclosureofOwnershipImage'))" />
                            </div>
                            <div class="flex justify-between items-center mt-1">
                                <div class="text-xs text-gray-500">
                                    <a *ngIf="document.get('disclosureofOwnershipImage')?.value" target="_blank"
                                        [href]="document.get('disclosureofOwnershipImage')?.value"
                                        class="underline text-blue-600 hover:text-blue-800 visited:text-purple-600">
                                        {{ getFileName(document.get('disclosureofOwnershipImage')?.value) }}
                                    </a>
                                </div>
                            </div>
                            <div class="flex justify-end gap-2" *ngIf="document.get('disclosureofOwnershipImage')?.value">
                                <button type="button" [appCopyToClipboard]="document.get('disclosureofOwnershipImage')?.value" copyLabel="document link" copyTooltip="Copy link"
                                    class="p-1 border border-zinc-400 dark:border-zinc-600 rounded bg-white dark:bg-zinc-900 text-zinc-900 dark:text-white hover:text-primary hover:border-primary dark:hover:text-primary dark:hover:border-primary flex items-center justify-center outline-none focus:outline-none">
                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-4 h-4">
                                        <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 17.25v3.375c0 .621-.504 1.125-1.125 1.125h-9.75a1.125 1.125 0 0 1-1.125-1.125V7.875c0-.621.504-1.125 1.125-1.125H6.75a9.06 9.06 0 0 1 1.5.124m7.5 10.376h3.375c.621 0 1.125-.504 1.125-1.125V11.25c0-4.46-3.243-8.161-7.5-8.876a9.06 9.06 0 0 0-1.5-.124H9.375c-.621 0-1.125.504-1.125 1.125v3.5m7.5 10.375H9.375a1.125 1.125 0 0 1-1.125-1.125v-9.25m12 6.625v-1.875a3.375 3.375 0 0 0-3.375-3.375h-1.5a1.125 1.125 0 0 1-1.125-1.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H9.75" />
                                    </svg>
                                </button>
                                <button type="button"
                                    (click)="deleteFile(document.get('disclosureofOwnershipImage'), disclosureofOwnershipImageInput)"
                                    class="p-1 border rounded bg-red-600 flex items-center justify-center outline-none focus:outline-none">
                                    <svg class="w-4 h-4 text-white" fill="currentColor" viewBox="0 0 20 20"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd"
                                            d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z"
                                            clip-rule="evenodd"></path>
                                    </svg>
                                </button>
                            </div>
                        </div>
                    </div>

                    <div class="space-y-1">
                        <label class="subheading">
                            EFT Form
                        </label>
                        <div>
                            <div>
                                <input #eFTFormImageInput type="file" accept="Image/*"
                                    (change)="uploadDocumentImages(eFTFormImageInput, document.get('eFTFormImage'))" />
                            </div>
                            <div class="flex justify-between items-center mt-1">
                                <div class="text-xs text-gray-500">
                                    <a *ngIf="document.get('eFTFormImage')?.value" target="_blank"
                                        [href]="document.get('eFTFormImage')?.value"
                                        class="underline text-blue-600 hover:text-blue-800 visited:text-purple-600">
                                        {{ getFileName(document.get('eFTFormImage')?.value) }}
                                    </a>
                                </div>
                            </div>
                            <div class="flex justify-end gap-2" *ngIf="document.get('eFTFormImage')?.value">
                                <button type="button" [appCopyToClipboard]="document.get('eFTFormImage')?.value" copyLabel="document link" copyTooltip="Copy link"
                                    class="p-1 border border-zinc-400 dark:border-zinc-600 rounded bg-white dark:bg-zinc-900 text-zinc-900 dark:text-white hover:text-primary hover:border-primary dark:hover:text-primary dark:hover:border-primary flex items-center justify-center outline-none focus:outline-none">
                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-4 h-4">
                                        <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 17.25v3.375c0 .621-.504 1.125-1.125 1.125h-9.75a1.125 1.125 0 0 1-1.125-1.125V7.875c0-.621.504-1.125 1.125-1.125H6.75a9.06 9.06 0 0 1 1.5.124m7.5 10.376h3.375c.621 0 1.125-.504 1.125-1.125V11.25c0-4.46-3.243-8.161-7.5-8.876a9.06 9.06 0 0 0-1.5-.124H9.375c-.621 0-1.125.504-1.125 1.125v3.5m7.5 10.375H9.375a1.125 1.125 0 0 1-1.125-1.125v-9.25m12 6.625v-1.875a3.375 3.375 0 0 0-3.375-3.375h-1.5a1.125 1.125 0 0 1-1.125-1.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H9.75" />
                                    </svg>
                                </button>
                                <button type="button" (click)="deleteFile(document.get('eFTFormImage'), eFTFormImageInput)"
                                    class="p-1 border rounded bg-red-600 flex items-center justify-center outline-none focus:outline-none">
                                    <svg class="w-4 h-4 text-white" fill="currentColor" viewBox="0 0 20 20"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd"
                                            d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z"
                                            clip-rule="evenodd"></path>
                                    </svg>
                                </button>
                            </div>
                        </div>
                    </div>

                    <div class="space-y-1">
                        <label class="subheading">
                            Voided Check
                        </label>
                        <div>
                            <div>
                                <input #voidedCheckImageInput type="file" accept="Image/*"
                                    (change)="uploadDocumentImages(voidedCheckImageInput, document.get('voidedCheckImage'))" />
                            </div>
                            <div class="flex justify-between items-center mt-1">
                                <div class="text-xs text-gray-500">
                                    <a *ngIf="document.get('voidedCheckImage')?.value" target="_blank"
                                        [href]="document.get('voidedCheckImage')?.value"
                                        class="underline text-blue-600 hover:text-blue-800 visited:text-purple-600">
                                        {{ getFileName(document.get('voidedCheckImage')?.value) }}
                                    </a>
                                </div>
                            </div>
                            <div class="flex justify-end gap-2" *ngIf="document.get('voidedCheckImage')?.value">
                                <button type="button" [appCopyToClipboard]="document.get('voidedCheckImage')?.value" copyLabel="document link" copyTooltip="Copy link"
                                    class="p-1 border border-zinc-400 dark:border-zinc-600 rounded bg-white dark:bg-zinc-900 text-zinc-900 dark:text-white hover:text-primary hover:border-primary dark:hover:text-primary dark:hover:border-primary flex items-center justify-center outline-none focus:outline-none">
                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-4 h-4">
                                        <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 17.25v3.375c0 .621-.504 1.125-1.125 1.125h-9.75a1.125 1.125 0 0 1-1.125-1.125V7.875c0-.621.504-1.125 1.125-1.125H6.75a9.06 9.06 0 0 1 1.5.124m7.5 10.376h3.375c.621 0 1.125-.504 1.125-1.125V11.25c0-4.46-3.243-8.161-7.5-8.876a9.06 9.06 0 0 0-1.5-.124H9.375c-.621 0-1.125.504-1.125 1.125v3.5m7.5 10.375H9.375a1.125 1.125 0 0 1-1.125-1.125v-9.25m12 6.625v-1.875a3.375 3.375 0 0 0-3.375-3.375h-1.5a1.125 1.125 0 0 1-1.125-1.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H9.75" />
                                    </svg>
                                </button>
                                <button type="button" (click)="deleteFile(document.get('voidedCheckImage'), voidedCheckImageInput)"
                                    class="p-1 border rounded bg-red-600 flex items-center justify-center outline-none focus:outline-none">
                                    <svg class="w-4 h-4 text-white" fill="currentColor" viewBox="0 0 20 20"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd"
                                            d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z"
                                            clip-rule="evenodd"></path>
                                    </svg>
                                </button>
                            </div>
                        </div>
                    </div>

                    <div class="space-y-1">
                        <label class="subheading">
                            Driver's Schedule
                        </label>
                        <div>
                            <div>
                                <input #driverScheduleImageInput type="file" accept="Image/*"
                                    (change)="uploadDocumentImages(driverScheduleImageInput, document.get('driverScheduleImage'))" />
                            </div>
                            <div class="flex justify-between items-center mt-1">
                                <div class="text-xs text-gray-500">
                                    <a *ngIf="document.get('driverScheduleImage')?.value" target="_blank"
                                        [href]="document.get('driverScheduleImage')?.value"
                                        class="underline text-blue-600 hover:text-blue-800 visited:text-purple-600">
                                        {{ getFileName(document.get('driverScheduleImage')?.value) }}
                                    </a>
                                </div>
                            </div>
                            <div class="flex justify-end gap-2" *ngIf="document.get('driverScheduleImage')?.value">
                                <button type="button" [appCopyToClipboard]="document.get('driverScheduleImage')?.value" copyLabel="document link" copyTooltip="Copy link"
                                    class="p-1 border border-zinc-400 dark:border-zinc-600 rounded bg-white dark:bg-zinc-900 text-zinc-900 dark:text-white hover:text-primary hover:border-primary dark:hover:text-primary dark:hover:border-primary flex items-center justify-center outline-none focus:outline-none">
                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-4 h-4">
                                        <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 17.25v3.375c0 .621-.504 1.125-1.125 1.125h-9.75a1.125 1.125 0 0 1-1.125-1.125V7.875c0-.621.504-1.125 1.125-1.125H6.75a9.06 9.06 0 0 1 1.5.124m7.5 10.376h3.375c.621 0 1.125-.504 1.125-1.125V11.25c0-4.46-3.243-8.161-7.5-8.876a9.06 9.06 0 0 0-1.5-.124H9.375c-.621 0-1.125.504-1.125 1.125v3.5m7.5 10.375H9.375a1.125 1.125 0 0 1-1.125-1.125v-9.25m12 6.625v-1.875a3.375 3.375 0 0 0-3.375-3.375h-1.5a1.125 1.125 0 0 1-1.125-1.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H9.75" />
                                    </svg>
                                </button>
                                <button type="button"
                                    (click)="deleteFile(document.get('driverScheduleImage'), driverScheduleImageInput)"
                                    class="p-1 border rounded bg-red-600 flex items-center justify-center outline-none focus:outline-none">
                                    <svg class="w-4 h-4 text-white" fill="currentColor" viewBox="0 0 20 20"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd"
                                            d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z"
                                            clip-rule="evenodd"></path>
                                    </svg>
                                </button>
                            </div>
                        </div>

                    </div>

                    <div class="space-y-1">
                        <label class="subheading">
                            Vehicle's Schedule
                        </label>
                        <div>
                            <div>
                                <input #vehicleScheduleImageInput type="file" accept="Image/*"
                                    (change)="uploadDocumentImages(vehicleScheduleImageInput, document.get('vehicleScheduleImage'))" />
                            </div>
                            <div class="flex justify-between items-center mt-1">
                                <div class="text-xs text-gray-500">
                                    <a *ngIf="document.get('vehicleScheduleImage')?.value" target="_blank"
                                        [href]="document.get('vehicleScheduleImage')?.value"
                                        class="underline text-blue-600 hover:text-blue-800 visited:text-purple-600">
                                        {{ getFileName(document.get('vehicleScheduleImage')?.value) }}
                                    </a>
                                </div>
                            </div>
                            <div class="flex justify-end gap-2" *ngIf="document.get('vehicleScheduleImage')?.value">
                                <button type="button" [appCopyToClipboard]="document.get('vehicleScheduleImage')?.value" copyLabel="document link" copyTooltip="Copy link"
                                    class="p-1 border border-zinc-400 dark:border-zinc-600 rounded bg-white dark:bg-zinc-900 text-zinc-900 dark:text-white hover:text-primary hover:border-primary dark:hover:text-primary dark:hover:border-primary flex items-center justify-center outline-none focus:outline-none">
                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-4 h-4">
                                        <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 17.25v3.375c0 .621-.504 1.125-1.125 1.125h-9.75a1.125 1.125 0 0 1-1.125-1.125V7.875c0-.621.504-1.125 1.125-1.125H6.75a9.06 9.06 0 0 1 1.5.124m7.5 10.376h3.375c.621 0 1.125-.504 1.125-1.125V11.25c0-4.46-3.243-8.161-7.5-8.876a9.06 9.06 0 0 0-1.5-.124H9.375c-.621 0-1.125.504-1.125 1.125v3.5m7.5 10.375H9.375a1.125 1.125 0 0 1-1.125-1.125v-9.25m12 6.625v-1.875a3.375 3.375 0 0 0-3.375-3.375h-1.5a1.125 1.125 0 0 1-1.125-1.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H9.75" />
                                    </svg>
                                </button>
                                <button type="button"
                                    (click)="deleteFile(document.get('vehicleScheduleImage'), vehicleScheduleImageInput)"
                                    class="p-1 border rounded bg-red-600 flex items-center justify-center outline-none focus:outline-none">
                                    <svg class="w-4 h-4 text-white" fill="currentColor" viewBox="0 0 20 20"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd"
                                            d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z"
                                            clip-rule="evenodd"></path>
                                    </svg>
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="space-y-1">
                        <label class="subheading">
                            Vehicle for Hire License
                        </label>
                        <div>
                            <div>
                                <input #vehicleForHireLicenseImageInput type="file" accept="Image/*"
                                    (change)="uploadDocumentImages(vehicleForHireLicenseImageInput, document.get('vehicleForHireLicenseImage'))" />
                            </div>
                            <div class="flex justify-between items-center mt-1">
                                <div class="text-xs text-gray-500">
                                    <a *ngIf="document.get('vehicleForHireLicenseImage')?.value" target="_blank"
                                        [href]="document.get('vehicleForHireLicenseImage')?.value"
                                        class="underline text-blue-600 hover:text-blue-800 visited:text-purple-600">
                                        {{ getFileName(document.get('vehicleForHireLicenseImage')?.value) }}
                                    </a>
                                </div>
                            </div>
                            <div class="flex justify-end gap-2" *ngIf="document.get('vehicleForHireLicenseImage')?.value">
                                <button type="button" [appCopyToClipboard]="document.get('vehicleForHireLicenseImage')?.value" copyLabel="document link" copyTooltip="Copy link"
                                    class="p-1 border border-zinc-400 dark:border-zinc-600 rounded bg-white dark:bg-zinc-900 text-zinc-900 dark:text-white hover:text-primary hover:border-primary dark:hover:text-primary dark:hover:border-primary flex items-center justify-center outline-none focus:outline-none">
                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-4 h-4">
                                        <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 17.25v3.375c0 .621-.504 1.125-1.125 1.125h-9.75a1.125 1.125 0 0 1-1.125-1.125V7.875c0-.621.504-1.125 1.125-1.125H6.75a9.06 9.06 0 0 1 1.5.124m7.5 10.376h3.375c.621 0 1.125-.504 1.125-1.125V11.25c0-4.46-3.243-8.161-7.5-8.876a9.06 9.06 0 0 0-1.5-.124H9.375c-.621 0-1.125.504-1.125 1.125v3.5m7.5 10.375H9.375a1.125 1.125 0 0 1-1.125-1.125v-9.25m12 6.625v-1.875a3.375 3.375 0 0 0-3.375-3.375h-1.5a1.125 1.125 0 0 1-1.125-1.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H9.75" />
                                    </svg>
                                </button>
                                <button type="button"
                                    (click)="deleteFile(document.get('vehicleForHireLicenseImage'), vehicleForHireLicenseImageInput)"
                                    class="p-1 border rounded bg-red-600 flex items-center justify-center outline-none focus:outline-none">
                                    <svg class="w-4 h-4 text-white" fill="currentColor" viewBox="0 0 20 20"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd"
                                            d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z"
                                            clip-rule="evenodd"></path>
                                    </svg>
                                </button>
                            </div>
                        </div>
                    </div>

                </ng-container>
            </section>
            <hr class="my-4 w-full border-t border-zinc-950/10 dark:border-white/10" />
            <h2 class="heading">
                Insurance Information
            </h2>
            <section class="mt-4 grid gap-4 sm:grid-cols-2">
                <ng-container formGroupName="insurance">
                    <div class="space-y-1">
                        <label class="subheading">
                            General Liability Insurance
                        </label>
                        <div>
                            <div>
                                <input #generalLiabilityInsuranceImageInput type="file" accept="Image/*"
                                    (change)="uploadDocumentImages(generalLiabilityInsuranceImageInput, insurance.get('generalLiabilityInsuranceImage'))" />
                            </div>
                            <div class="flex justify-between items-center mt-1">
                                <div class="text-xs text-gray-500">
                                    <a *ngIf="insurance.get('generalLiabilityInsuranceImage')?.value" target="_blank"
                                        [href]="insurance.get('generalLiabilityInsuranceImage')?.value"
                                        class="underline text-blue-600 hover:text-blue-800 visited:text-purple-600">
                                        {{ getFileName(insurance.get('generalLiabilityInsuranceImage')?.value) }}
                                    </a>
                                </div>
                            </div>
                            <div class="flex justify-end gap-2"
                                *ngIf="insurance.get('generalLiabilityInsuranceImage')?.value">
                                <button type="button" [appCopyToClipboard]="insurance.get('generalLiabilityInsuranceImage')?.value" copyLabel="document link" copyTooltip="Copy link"
                                    class="p-1 border border-zinc-400 dark:border-zinc-600 rounded bg-white dark:bg-zinc-900 text-zinc-900 dark:text-white hover:text-primary hover:border-primary dark:hover:text-primary dark:hover:border-primary flex items-center justify-center outline-none focus:outline-none">
                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-4 h-4">
                                        <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 17.25v3.375c0 .621-.504 1.125-1.125 1.125h-9.75a1.125 1.125 0 0 1-1.125-1.125V7.875c0-.621.504-1.125 1.125-1.125H6.75a9.06 9.06 0 0 1 1.5.124m7.5 10.376h3.375c.621 0 1.125-.504 1.125-1.125V11.25c0-4.46-3.243-8.161-7.5-8.876a9.06 9.06 0 0 0-1.5-.124H9.375c-.621 0-1.125.504-1.125 1.125v3.5m7.5 10.375H9.375a1.125 1.125 0 0 1-1.125-1.125v-9.25m12 6.625v-1.875a3.375 3.375 0 0 0-3.375-3.375h-1.5a1.125 1.125 0 0 1-1.125-1.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H9.75" />
                                    </svg>
                                </button>
                                <button type="button"
                                    (click)="deleteFile(insurance.get('generalLiabilityInsuranceImage'), generalLiabilityInsuranceImageInput)"
                                    class="p-1 border rounded bg-red-600 flex items-center justify-center outline-none focus:outline-none">
                                    <svg class="w-4 h-4 text-white" fill="currentColor" viewBox="0 0 20 20"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd"
                                            d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z"
                                            clip-rule="evenodd"></path>
                                    </svg>
                                </button>
                            </div>
                        </div>
                    </div>

                    <div class="space-y-1">
                        <label class="subheading">
                            General Liability Date
                        </label>
                        <div>
                            <div>
                                <input type="text" name="time" id="time" formControlName="generalLiabilityInsuranceDate"
                                    [owlDateTime]="dtgeneralLiabilityInsuranceDate"
                                    [owlDateTimeTrigger]="dtgeneralLiabilityInsuranceDate"
                                    [max]="insurance.get('generalLiabilityInsuranceExpireDate')?.value" [readonly]="true" />
                                <owl-date-time [pickerType]="'calendar'"
                                    (afterPickerClosed)="onDateChange(insurance.get('generalLiabilityInsuranceDate'))"
                                    #dtgeneralLiabilityInsuranceDate></owl-date-time>
                            </div>
                        </div>
                    </div>


                    <div class="space-y-1">
                        <label class="subheading">
                            General Liability Expiration Date
                        </label>
                        <div>
                            <div>
                                <input type="text" name="time" id="time"
                                    formControlName="generalLiabilityInsuranceExpireDate"
                                    [owlDateTime]="generalLiabilityInsuranceExpireDate"
                                    [owlDateTimeTrigger]="generalLiabilityInsuranceExpireDate"
                                    [min]="insurance.get('generalLiabilityInsuranceDate')?.value" [readonly]="true" />
                                <owl-date-time [pickerType]="'calendar'"
                                    (afterPickerClosed)="onDateChange(insurance.get('generalLiabilityInsuranceExpireDate'))"
                                    #generalLiabilityInsuranceExpireDate></owl-date-time>
                            </div>
                        </div>
                        <div *ngIf="submitted && insurance.get('generalLiabilityInsuranceExpireDate')?.errors">
                            <p *ngIf="insurance.get('generalLiabilityInsuranceExpireDate')?.errors?.dateMismatch"
                                class="pt-1 text-red-600 text-xs">
                                General Liability Expiration Date must be after General Liability Date
                            </p>
                        </div>
                    </div>

                    <div class="space-y-1">
                        <label class="subheading">
                            Auto Liability Insurance
                        </label>
                        <div>
                            <div>
                                <input #autoLiabilityInsuranceImageInput type="file" accept="Image/*"
                                    (change)="uploadDocumentImages(autoLiabilityInsuranceImageInput, insurance.get('autoLiabilityInsuranceImage'))" />
                            </div>
                            <div class="flex justify-between items-center mt-1">
                                <div class="text-xs text-gray-500">
                                    <a *ngIf="insurance.get('autoLiabilityInsuranceImage')?.value" target="_blank"
                                        [href]="insurance.get('autoLiabilityInsuranceImage')?.value"
                                        class="underline text-blue-600 hover:text-blue-800 visited:text-purple-600">
                                        {{ getFileName(insurance.get('autoLiabilityInsuranceImage')?.value) }}
                                    </a>
                                </div>
                            </div>
                            <div class="flex justify-end gap-2" *ngIf="insurance.get('autoLiabilityInsuranceImage')?.value">
                                <button type="button" [appCopyToClipboard]="insurance.get('autoLiabilityInsuranceImage')?.value" copyLabel="document link" copyTooltip="Copy link"
                                    class="p-1 border border-zinc-400 dark:border-zinc-600 rounded bg-white dark:bg-zinc-900 text-zinc-900 dark:text-white hover:text-primary hover:border-primary dark:hover:text-primary dark:hover:border-primary flex items-center justify-center outline-none focus:outline-none">
                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-4 h-4">
                                        <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 17.25v3.375c0 .621-.504 1.125-1.125 1.125h-9.75a1.125 1.125 0 0 1-1.125-1.125V7.875c0-.621.504-1.125 1.125-1.125H6.75a9.06 9.06 0 0 1 1.5.124m7.5 10.376h3.375c.621 0 1.125-.504 1.125-1.125V11.25c0-4.46-3.243-8.161-7.5-8.876a9.06 9.06 0 0 0-1.5-.124H9.375c-.621 0-1.125.504-1.125 1.125v3.5m7.5 10.375H9.375a1.125 1.125 0 0 1-1.125-1.125v-9.25m12 6.625v-1.875a3.375 3.375 0 0 0-3.375-3.375h-1.5a1.125 1.125 0 0 1-1.125-1.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H9.75" />
                                    </svg>
                                </button>
                                <button type="button"
                                    (click)="deleteFile(insurance.get('autoLiabilityInsuranceImage'), autoLiabilityInsuranceImageInput)"
                                    class="p-1 border rounded bg-red-600 flex items-center justify-center outline-none focus:outline-none">
                                    <svg class="w-4 h-4 text-white" fill="currentColor" viewBox="0 0 20 20"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd"
                                            d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z"
                                            clip-rule="evenodd"></path>
                                    </svg>
                                </button>
                            </div>
                        </div>
                    </div>

                    <div class="space-y-1">
                        <label class="subheading">
                            Auto Liability Date
                        </label>
                        <div>
                            <div>
                                <input type="text" name="time" id="time" formControlName="autoLiabilityInsuranceDate"
                                    [owlDateTime]="dtautoLiabilityInsuranceDate"
                                    [owlDateTimeTrigger]="dtautoLiabilityInsuranceDate"
                                    [max]="insurance.get('autoLiabilityInsuranceExpireDate')?.value" [readonly]="true" />
                                <owl-date-time [pickerType]="'calendar'"
                                    (afterPickerClosed)="onDateChange(insurance.get('autoLiabilityInsuranceDate'))"
                                    #dtautoLiabilityInsuranceDate></owl-date-time>
                            </div>
                        </div>
                    </div>

                    <div class="space-y-1">
                        <label class="subheading">
                            Auto Liability Expiration Date
                        </label>
                        <div>
                            <div>
                                <input type="text" name="time" id="time"
                                    formControlName="autoLiabilityInsuranceExpireDate"
                                    [owlDateTime]="autoLiabilityInsuranceExpireDate"
                                    [owlDateTimeTrigger]="autoLiabilityInsuranceExpireDate"
                                    [min]="insurance.get('autoLiabilityInsuranceDate')?.value" [readonly]="true" />
                                <owl-date-time [pickerType]="'calendar'"
                                    (afterPickerClosed)="onDateChange(insurance.get('autoLiabilityInsuranceExpireDate'))"
                                    #autoLiabilityInsuranceExpireDate></owl-date-time>
                            </div>
                        </div>
                        <div *ngIf="submitted && insurance.get('autoLiabilityInsuranceExpireDate')?.errors">
                            <p *ngIf="insurance.get('autoLiabilityInsuranceExpireDate')?.errors?.dateMismatch"
                                class="pt-1 text-red-600 text-xs">
                                Auto Liability Expiration Date must be after Auto Liability Date
                            </p>
                        </div>
                    </div>
                    <div class="space-y-1">
                        <label class="subheading">
                            COI For Worker Compensation
                        </label>
                        <div>
                            <div>
                                <input #workerCOIImageInput type="file" accept="Image/*"
                                    (change)="uploadDocumentImages(workerCOIImageInput, insurance.get('workerCOIImage'))" />
                            </div>
                            <div class="flex justify-between items-center mt-1">
                                <div class="text-xs text-gray-500">
                                    <a *ngIf="insurance.get('workerCOIImage')?.value" target="_blank"
                                        [href]="insurance.get('workerCOIImage')?.value"
                                        class="underline text-blue-600 hover:text-blue-800 visited:text-purple-600">
                                        {{ getFileName(insurance.get('workerCOIImage')?.value) }}
                                    </a>
                                </div>
                            </div>
                            <div class="flex justify-end gap-2" *ngIf="insurance.get('workerCOIImage')?.value">
                                <button type="button" [appCopyToClipboard]="insurance.get('workerCOIImage')?.value" copyLabel="document link" copyTooltip="Copy link"
                                    class="p-1 border border-zinc-400 dark:border-zinc-600 rounded bg-white dark:bg-zinc-900 text-zinc-900 dark:text-white hover:text-primary hover:border-primary dark:hover:text-primary dark:hover:border-primary flex items-center justify-center outline-none focus:outline-none">
                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-4 h-4">
                                        <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 17.25v3.375c0 .621-.504 1.125-1.125 1.125h-9.75a1.125 1.125 0 0 1-1.125-1.125V7.875c0-.621.504-1.125 1.125-1.125H6.75a9.06 9.06 0 0 1 1.5.124m7.5 10.376h3.375c.621 0 1.125-.504 1.125-1.125V11.25c0-4.46-3.243-8.161-7.5-8.876a9.06 9.06 0 0 0-1.5-.124H9.375c-.621 0-1.125.504-1.125 1.125v3.5m7.5 10.375H9.375a1.125 1.125 0 0 1-1.125-1.125v-9.25m12 6.625v-1.875a3.375 3.375 0 0 0-3.375-3.375h-1.5a1.125 1.125 0 0 1-1.125-1.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H9.75" />
                                    </svg>
                                </button>
                                <button type="button" (click)="deleteFile(insurance.get('workerCOIImage'), workerCOIImageInput)"
                                    class="p-1 border rounded bg-red-600 flex items-center justify-center outline-none focus:outline-none">
                                    <svg class="w-4 h-4 text-white" fill="currentColor" viewBox="0 0 20 20"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd"
                                            d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z"
                                            clip-rule="evenodd"></path>
                                    </svg>
                                </button>
                            </div>
                        </div>
                    </div>
                    
                    <div class="space-y-1">
                        <label class="subheading">
                            COI For Worker Compensation Expiration Date
                        </label>
                        <div>
                            <div>
                                <input type="text" name="time" id="time" formControlName="workerCOIImageExpireDate"
                                    [owlDateTime]="workerCOIImageExpireDate" [owlDateTimeTrigger]="workerCOIImageExpireDate"
                                     />
                                <owl-date-time [pickerType]="'calendar'"
                                    (afterPickerClosed)="onDateChange(insurance.get('workerCOIImageExpireDate'))"
                                    #workerCOIImageExpireDate></owl-date-time>
                            </div>
                        </div>
                        <div *ngIf="submitted && insurance.get('workerCOIImageExpireDate')?.errors">
                            <p *ngIf="insurance.get('workerCOIImageExpireDate')?.errors?.dateMismatch" class="pt-1 text-red-600 text-xs">
                                Expiration Date must be a valid Date
                            </p>
                        </div>
                    </div>
                </ng-container>
            </section>
            <hr class="my-4 w-full border-t border-zinc-950/10 dark:border-white/10" />
            <h2 class="heading">
                Bank Information
            </h2>
            <section class="mt-4 grid gap-4 sm:grid-cols-2">
                <ng-container formGroupName="bankDetails">
                    <div class="space-y-1">
                        <label class="subheading">
                            Bank Name
                        </label>
                        <div>
                            <div>
                                <input formControlName="name" type="tel" />
                            </div>
                        </div>
                    </div>
                    <div class="space-y-1">
                        <label class="subheading">
                            Account Number
                        </label>
                        <div>
                            <div>
                                <input formControlName="accountNumber" type="text" />
                            </div>
                        </div>
                    </div>
                    <div class="space-y-1">
                        <label class="subheading">
                            Routing Number
                        </label>
                        <div>
                            <div>
                                <input formControlName="routingNumber" type="text" />
                            </div>
                        </div>
                    </div>
                </ng-container>
                <div class="space-y-1">
                    <label class="subheading">
                        Status
                    </label>
                    <div>
                        <div>
                            <select formControlName="isActive">
                                <option [value]="true">Active</option>
                                <option [value]="false">Inactive</option>
                            </select>
                        </div>
                        <div *ngIf="submitted && form.isActive.errors">
                            <p *ngIf="form.isActive.errors.required" class="pt-1 text-red-600 text-xs">
                                Status is required
                            </p>
                        </div>
                    </div>
                </div>
            </section>



             <hr class="my-4 w-full border-t border-zinc-950/10 dark:border-white/10" />
            <h2 class="heading">
                Tax Information
            </h2>
            <section class="mt-4 grid gap-4 sm:grid-cols-2">
                <ng-container formGroupName="taxInformation">
                    <div class="space-y-1">
                        <label class="subheading">
                         Name
                        </label>
                        <div>
                            <div>
                                <input formControlName="name" type="tel" />
                            </div>
                        </div>
                    </div>
                    <div class="space-y-1">
                        <label class="subheading">
                            Npi
                        </label>
                        <div>
                            <div>
                                <input formControlName="npi" type="text" />
                            </div>
                        </div>
                    </div>
                    <div class="space-y-1">
                        <label class="subheading">
                            Tax Id
                        </label>
                        <div>
                            <div>
                                <input formControlName="taxId" type="text" />
                            </div>
                        </div>
                    </div>
                     <div class="space-y-1">
                        <label class="subheading">
                            Taxonomy
                        </label>
                        <div>
                            <div>
                                <input formControlName="taxonomy" type="text" />
                            </div>
                        </div>
                    </div>
                </ng-container>
            </section>


             <hr class="my-4 w-full border-t border-zinc-950/10 dark:border-white/10" />
            <h2 class="heading">
                Focal Person Information
            </h2>
            <section class="mt-4 grid gap-4 sm:grid-cols-2">
                <ng-container formGroupName="focalPersonInformation">
                    <div class="space-y-1">
                        <label class="subheading">
                         Name
                        </label>
                        <div>
                            <div>
                                <input formControlName="name" type="tel" />
                            </div>
                        </div>
                    </div>
                    <div class="space-y-1">
                        <label class="subheading">
                            Email
                        </label>
                        <div>
                            <div>
                                <input formControlName="email" type="text" />
                            </div>
                        </div>
                    </div>
                    <div class="space-y-1">
                        <label class="subheading">
                            Contact Number
                        </label>
                        <div>
                            <div>
                                <input formControlName="contactNumber" type="text" />
                            </div>
                            <div>
                                <p *ngIf="submitted && (focalPersonForm.get('contactNumber')?.errors?.minlength || focalPersonForm.get('contactNumber')?.errors?.maxlength)"
                                    class="pt-1 text-red-600 text-xs">
                                    Minimum 10 digits are required and maximum 13 digits are allowed
                                </p>
                            </div>
                        </div>
                    </div>
                     <div class="space-y-1">
                        <label class="subheading">
                            Phone Number
                        </label>
                        <div>
                            <div>
                                <input formControlName="phoneNumber" type="text" />
                            </div>
                            <div>
                                <p *ngIf="submitted && (focalPersonForm.get('phoneNumber')?.errors?.minlength || focalPersonForm.get('phoneNumber')?.errors?.maxlength)"
                                    class="pt-1 text-red-600 text-xs">
                                    Minimum 10 digits are required and maximum 13 digits are allowed
                                </p>
                            </div>
                        </div>
                    </div>
                </ng-container>
            </section>

            <hr class="my-4 w-full border-t border-zinc-950/10 dark:border-white/10" />
            <section class="flex justify-end gap-4">
                <button type="button" (click)="onSave()" class="btn btn-secondary">
                    {{companyId ? 'Update' : 'Create'}}
                </button>
            </section>
        </form>
    </div>
</section>